export enum ExternalLink {
    PRIVACY = 'https://bumble.com/privacy',
    TERMS = 'https://bumble.com/terms',
    NOTICE_AT_COLLECTION = 'https://bumbcdn.com/big/documents/bumble/2024/bumble_california_notice_at_collection.pdf',
    SAFETY_CENTRE = 'https://safety.bumble.com',
    APP_STORE_ANDROID = 'https://app.appsflyer.com/com.bumble.app?pid=googleplayhomepage',
    APP_STORE_IOS = 'https://app.appsflyer.com/id930441707?pid=appstorehomepage',
}
